import React, { useState, useEffect } from 'react';
import { getdevices } from '../../Restclient/datacollection';
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { useSelector } from "react-redux";
import '../../cssfiles/homepage.css';

export default function DeviceSelection({ setSelectedDevices = () => {} }) {
    const [devicesdata, setDevicesData] = useState([]);
    const [selectedDevices, setSelectedDevicesState] = useState([]); // Array of selected device objects
    const selectedprojectname = useSelector((state) => state.mainpagedata.selectedprojectname)
    const { PermissionsArray: usrPrmns } = useSelector((state) => state.logindata.userdetails);
    const devicescallback = (res) => {
        setDevicesData(res);
    };

    useEffect(() => {
        if (usrPrmns.includes("PJDF29")) {
            getdevices(devicescallback);
        }
    }, [selectedprojectname]);

    // Handle checkbox toggle
    const handleDeviceCheck = (device) => {
        setSelectedDevicesState((prevSelected) => {
            let updated;
            if (prevSelected.some(d => d.DeviceID === device.DeviceID)) {
                updated = prevSelected.filter(d => d.DeviceID !== device.DeviceID);
            } else {
                updated = [...prevSelected, device];
            }
            setSelectedDevices(updated); // Output the array of selected device objects
            return updated;
        });
    };

    return (
        <div style={{ width: '100%', marginTop: "3px", border: "1px solid #008CD7", marginLeft: "8px", boxSizing: "border-box", overflowY: 'scroll', height: `calc(100vh - 480px)` }}>
            <SimpleTreeView
                sx={{
                    color: "var(--SecondaryText)",
                    "& .MuiTreeItem-label .MuiTreeItem-content": {
                        fontSize: "16px",
                        fontWeight: 400,
                        color: "red",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textAlign: "left",
                    },
                }}
                defaultCollapseIcon="-"
                defaultExpandIcon="+"
            >
                {devicesdata.map((device) => (
                    <TreeItem
                        key={device.DeviceID}
                        itemId={device.DeviceID}
                        sx={{ textAlign: 'left' }}
                        label={
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checkedIcon={<CheckBoxOutlinedIcon />}  style={{color:'var(--SecondaryText)', color:"#008CD7"}}
                                        checked={selectedDevices.some(d => d.DeviceID === device.DeviceID)}
                                        onChange={() => handleDeviceCheck(device)}
                                        sx={{
                                            padding: 0,
                                            margin: 0,
                                            color: 'var(--HighlightedText_Stroke)',
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '20px',
                                                color: 'var(--HighlightedText_Stroke)'
                                            }
                                        }}
                                    />
                                }
                                label={device.Name}
                                sx={{ textAlign: "left" }}
                            />
                        }
                    />
                ))}
            </SimpleTreeView>
        </div>
    );
}